"use Strict";
import React, { ReactElement, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Faqs from "../../component/home/faqs";
import Exclusions from "../../component/home/exclusions";
import KeyFeatures from "../../component/home/keyFeatures";
import WhyChooseUs from "../../component/home/whyChooseUs";
import Banner from "../../component/home/banner";
import { useTranslation } from "react-i18next";

export default function SolarHome(): ReactElement {
  const { t } = useTranslation();
  return (
    <div style={{overflowX:"hidden"}} className="landing-page-wrapper">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("solar_title")}</title>
        <link
          rel="canonical"
          href="https://takafulbazaar.pk/solar"
        />
        <meta
          name="description"
          content="Solar"
        />
      </Helmet>
      <Banner />
      <WhyChooseUs />
      <KeyFeatures />
      <Exclusions />
      <Faqs />

    </div>
  );
}
